// The Frontier's actions, drawn. Same idea as buildingArt.js and
// loreArt.js: constant line art in a 24x24 box, stroked in currentColor,
// nothing to load. A tile with an emblem is scannable; a row of words is a
// list of buttons, which is what the other three boards stopped being.

export const FRONTIER_ART = {
  // A drawn bow and its arrow: the hunt.
  hunt: '<path d="M18.5 5.5A13 13 0 0 1 5.5 18.5"/><path d="M4.5 19.5 19 5"/><path d="M14.5 5h5v5"/>',
  // A watchtower on its footing.
  outpost: '<path d="M8 21V9.5l4-3 4 3V21"/><path d="M5.5 21h13"/><path d="M8 9.5h8"/><path d="M11 21v-4.5h2V21"/><path d="M8 6.5v-2M12 5v-2M16 6.5v-2"/>',
  // Two people, and one more joining.
  muster: '<circle cx="8.5" cy="7" r="3"/><path d="M3 20a5.5 5.5 0 0 1 11 0"/><path d="M18.5 8.5v6M15.5 11.5h6"/>',
  // Everyone walks back in under the roof.
  'stand-down': '<path d="M3.5 11 12 4l8.5 7"/><path d="M6 10.5V20h12v-9.5"/><path d="M12 20v-6.5"/><path d="M9.5 16.5 12 19l2.5-2.5"/>',
  // Climb something and look.
  scout: '<path d="M2 12s3.6-6 10-6 10 6 10 6-3.6 6-10 6-10-6-10-6Z"/><circle cx="12" cy="12" r="2.6"/>',
  // Crossed blades.
  fight: '<path d="m4 4 9.5 9.5"/><path d="m20 4-9.5 9.5"/><path d="m3 17.5 3.5-3.5 3 3-3.5 3.5Z"/><path d="m21 17.5-3.5-3.5-3 3 3.5 3.5Z"/>',
  // A flag of truce.
  raid: '<path d="m4 4 9.5 9.5"/><path d="m20 4-9.5 9.5"/><path d="m3 17.5 3.5-3.5 3 3-3.5 3.5Z"/><path d="m21 17.5-3.5-3.5-3 3 3.5 3.5Z"/><path d="M9 21h6"/>',
  rival: '<path d="M12 3v18"/><path d="M12 4.5h8l-2.5 3.5 2.5 3.5h-8Z"/><path d="M6 21h12"/>',
  parley: '<path d="M6 21V3"/><path d="M6 4.5h11l-2.5 4 2.5 4H6Z"/>',
  // The band itself: people on the move.
  band: '<circle cx="8" cy="7.5" r="3"/><path d="M2.5 20a5.5 5.5 0 0 1 11 0"/><circle cx="17" cy="9" r="2.4"/><path d="M13.5 20a4.2 4.2 0 0 1 8 0"/>',
  // A roof going up on open ground: a village planted.
  // A road running away into the distance.
  road: '<path d="M9 21 11 3"/><path d="M15 21 13 3"/><path d="M12 19v-2"/><path d="M12 13v-2"/><path d="M12 7V6"/>',
  found: '<path d="M3 11.5 12 4.5l9 7"/><path d="M5.5 10.5V20h13v-9.5"/><path d="M10 20v-5h4v5"/>',
  // Mend what the raiders broke.
  'repair-village': '<path d="M14.5 6.5a4 4 0 0 0 5.2 5.2l-7.4 7.4a2.3 2.3 0 0 1-3.3-3.3Z"/><path d="m5 5 3.5 3.5"/><path d="M4 9.5 8.5 5"/>',
  // The ground worked, whatever it gives.
  forage: '<path d="M18.5 5.5A13 13 0 0 1 5.5 18.5"/><path d="M4.5 19.5 19 5"/><path d="M14.5 5h5v5"/>',
  // One step at a time.
  move: '<path d="M7.5 20.5c-1.6-.6-2.2-2.2-1.6-3.8l2.6-6.9c.6-1.6 2.2-2.2 3.5-1.6 1.4.6 1.9 2.2 1.3 3.8l-2.6 6.9c-.6 1.6-1.7 2.2-3.2 1.6Z"/><path d="M16 12.5c-1.5-.6-2-2-1.5-3.4l1.3-3.4c.6-1.5 2-2 3.2-1.4 1.3.6 1.7 2 1.1 3.4l-1.3 3.4c-.5 1.5-1.4 2-2.8 1.4Z"/>',
  // Boots on the ground: how far the band walks in a day.
  march: '<path d="M7.5 20.5c-1.6-.6-2.2-2.2-1.6-3.8l2.6-6.9c.6-1.6 2.2-2.2 3.5-1.6 1.4.6 1.9 2.2 1.3 3.8l-2.6 6.9c-.6 1.6-1.7 2.2-3.2 1.6Z"/><path d="M16 12.5c-1.5-.6-2-2-1.5-3.4l1.3-3.4c.6-1.5 2-2 3.2-1.4 1.3.6 1.7 2 1.1 3.4l-1.3 3.4c-.5 1.5-1.4 2-2.8 1.4Z"/>',
  // What is out there: a camp under the stars.
  menace: '<path d="M12 5 4 20h16Z"/><path d="M12 5v15"/>',
};

export const artForFrontier = (id) => FRONTIER_ART[id] || FRONTIER_ART.scout;
